export default __webpack_public_path__ + "static/media/prev-arrow-no-outline.be8a74d1.svg";